const convert2NegativeValue = (value) =>
  typeof value === "number" ? -value : value;

export default convert2NegativeValue;
